import { makeStyles } from '@material-ui/core';
import clsx from 'clsx';
import React from 'react';
import { SelectInput as RaSelectInput, useTranslate } from 'react-admin';

const SelectInput = (props) => {
  const t = useTranslate();
  const classes = useStyles();
  return (
    <RaSelectInput
      resettable
      variant="outlined"
      options={{
        SelectProps: {
          ...props.options?.SelectProps,
          MenuProps: {
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'left',
            },
            transformOrigin: {
              vertical: 'top',
              horizontal: 'left',
            },
            getContentAnchorEl: null,
            ...props.options?.SelectProps?.MenuProps,
            classes: {
              ...props.options?.SelectProps?.MenuProps?.classes,
              list: clsx(classes.menuList, props.options?.SelectProps?.MenuProps?.classes?.list),
            },
          },
        },
      }}
      allowEmpty={!props.choices?.length}
      emptyText={t('common.text.noOptions')}
      optionDisabled={(record) => !record}
      {...props}
    />
  );
};

export default SelectInput;

const useStyles = makeStyles((theme) => ({
  menuList: {
    '& li[data-value][aria-label="Clear value"]': {
      pointerEvents: 'none',
      color: theme.palette.grey[700],
      opacity: 0.7,
      fontStyle: 'italic',
      backgroundColor: 'transparent',
    },
  },
}));
